import api from "./api";
import qs from "qs";

export default {
  fetchAllForUser(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `films`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.films);
        }
      );
    });
  },

  fetchAllForEventBucket(apiKey, eventBucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${eventBucket}/films`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.films);
        }
      );
    });
  },

  fetchAllByTag(apiKey, eventBucket, tag, params = {}) {
    let newParams = { ...params }

    if (params.sorted && params.sorted.length !== 0) {
      newParams = { ...newParams, sortedId: params.sorted[0].id, sortedIsDesc: params.sorted[0].desc }
    }

    return new Promise((resolve, reject) => {
      api.request({
        method: "GET",
        endpoint: `/event_buckets/${eventBucket}/tags/${tag}/films?${qs.stringify(newParams)}`,
        api_key: apiKey
      }, function (err, response) {
        if (err) {
          return reject(err);
        }
        resolve(response);
      })
    })
  },

  fetchAllForCreator(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `films?content_creator=true`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.films);
        }
      );
    });
  },

  fetchOne(apiKey, film) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `films/${film}`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  edit(apiKey, film, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `films/${film}`,
          json: values,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  editImage(apiKey, film, field, file) {
    return new Promise((resolve, reject) => {
      api.request(
        Object.assign(
          {
            method: "POST",
            endpoint: `films/${film}`,
            api_key: apiKey
          },
          file
            ? { fileField: field, file: file }
            : {
                json: { [field]: null }
              }
        ),
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  delete(apiKey, film) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "DELETE",
          endpoint: `films/${film}`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  create(apiKey, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `films`,
          json: values,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  inviteContentCreator(apiKey, filmId, email, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `films/${filmId}/content_creator_invite`,
          json: {
            email,
            ...(options
              ? { title_requested_media: options.title_requested_media }
              : null)
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/FilmUtil.js